
 import { yupToFormErrors } from "formik";
 import * as Yup from "yup";
 
const TODIS_RESEND = {
    remarks: ""
};

 const RESEND = Yup.object().shape({
    //general section Rules:
    remarks: Yup.string("Remark is alphanumeric").required('Required'),
});

export { RESEND, TODIS_RESEND };